export type VisitsReportType = "screen" | "excel";

export type BuildVisitsReportPayloadParams = {
  filterKey: "owner_id" | "property_id";
  filterId: number;
  type: VisitsReportType;
  initialDate?: string;
  finalDate?: string;
};

export function buildVisitsReportPayload({
  filterKey,
  filterId,
  type,
  initialDate,
  finalDate,
}: BuildVisitsReportPayloadParams): Record<string, string | number> {
  const payload: Record<string, string | number> = {
    [filterKey]: filterId,
    type,
  };

  if (initialDate) {
    payload.initial_date = initialDate;
  }

  if (finalDate) {
    payload.final_date = finalDate;
  }

  return payload;
}

export function buildVisitsReportDatesState(
  initialDate?: string,
  finalDate?: string
): string[] | undefined {
  if (!initialDate && !finalDate) {
    return undefined;
  }

  return [initialDate ?? "", finalDate ?? ""];
}
